import Logo from '../components/logo';
import StickyContent from '../components/sticky-content';
import JumpMarkNavigation from '../components/jump-mark-navigation';
import Slider from '../components/slider';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import lity from 'lity/dist/lity.js';
import stickybits from "stickybits";
import ScrollMenu from "../components/scroll-menu";
import AnimateDigits from "../components/animate-digits";

export default {
  init() {
    /*
    function onElementHeightChange(elm, callback) {
      var lastHeight = elm.clientHeight, newHeight;

      (function run() {
        newHeight = elm.clientHeight;
        if (lastHeight != newHeight)
          callback(newHeight)
        lastHeight = newHeight

        if (elm.onElementHeightChangeTimer)
          clearTimeout(elm.onElementHeightChangeTimer)

        elm.onElementHeightChangeTimer = setTimeout(run, 200)
      })()
    }
     */

    // Show content after WPBakery is fully loaded
    const el = document.querySelector('.c-application-content');
    el.style.opacity = 1;

    // Add Logo animation
    new Logo();

    // Add slider
    new Slider('.c-highlights-slider__slider', {
      autoplay: {
        delay: 5500,
      },
    });

    new Slider('.c-city-stories-slider__slider', {
      autoplay: {
        delay: 4000,
      },
    });

    new Slider('.c-video-teaser__slider', {
      autoplay: {
        delay: 3500,
      },
    });

    // Add lity lightbox to all elments with the data-lity attribute
    lity

    // Sticky content on all pages
    const stickyContents = document.querySelectorAll('.u-sticky-content');
    stickyContents.forEach((element, index) => {
      new StickyContent({
        element: element,
        offset: 168,
        debugId: 'element ' + index,
      });
    });

    $('.sticky-new:not(.without-stickybits)').each(function(index, value) {
      stickybits(value, {
        useFixed: true,
        stickClass: 'sticky-new-start',
        stuckClass: 'sticky-new-end',
        stickyChangeClass: 'sticky-new-progress',
        stickyBitStickyOffset: 75
      });

      $(value).css("top", "");
    });


    /*
    onElementHeightChange(document.body, () => {
      const stickybitsInstancetoBeUpdated = stickybits('.sticky-new');
      stickybitsInstancetoBeUpdated.cleanup();

      stickybits('.sticky-new', {
        useFixed: true,
        stickClass: 'sticky-new-start',
        stuckClass: 'sticky-new-end',
        stickyChangeClass: 'sticky-new-progress',
        stickyBitStickyOffset: 75
      });

      $(window).scroll();
    });
     */

    $('.c-page__content > div.vc_row').first().css('margin-top', '75px');

    var scroll_menu = new ScrollMenu();
    scroll_menu.init();

    var animate_digits = new AnimateDigits();
    animate_digits.init();

    // Add jump mark navigation
    new JumpMarkNavigation({
      idPrefix: 'jump-mark'
    });

    // Burger Menu
    document.querySelector('.c-burger-menu').addEventListener('click', function () {
      document.querySelector('.c-application-header').classList.toggle('c-application-header--is-open');
    });

    // Masonry news grid
    var grid = document.querySelector('.c-page__entry-list');
    if (grid) {
      imagesLoaded(grid, function () {
        new Masonry(grid, {
          itemSelector: '.c-entry',
        });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js